var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';
import useKeyPress from '@ally/use-key-press';
import { TextBody } from '../../../../Typography';
export var baseAutoCompleteA11yProps = {
    role: 'combobox',
    'aria-autocomplete': 'both',
    'aria-expanded': 'false',
};
var OptionsList = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var colors = _a.theme.colors;
    return "\n    background: ".concat(colors.white, ";\n    padding: 0;\n    margin: 0;\n  ");
});
var OptionsItem = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"
    // no need for uuid
    // only one auto-complete can be opened at a time
])), function (_a) {
    var _b = _a.theme, colors = _b.colors, space = _b.space;
    return "\n    background: ".concat(colors.white, ";\n    padding: ").concat(space.xs, " ").concat(space.md, ";\n    list-style: none;\n\n    &:hover, &:focus {\n      cursor: pointer;\n      background: ").concat(colors['page-gray'], ";\n      outline: none;\n    }\n  ");
});
// no need for uuid
// only one auto-complete can be opened at a time
var domId = function (index) { return "mui-auto-complete-".concat(index); };
var AutoCompleteSelect = function (_a) {
    var options = _a.options, onSelect = _a.onSelect, onA11yPropsUpdate = _a.onA11yPropsUpdate;
    var listId = useRef("mui-auto-complete-list-".concat(uuid())).current;
    var _b = __read(useState(null), 2), focusIndex = _b[0], setFocusIndex = _b[1];
    useEffect(function () {
        onA11yPropsUpdate({
            role: 'combobox',
            'aria-expanded': 'true',
            'aria-autocomplete': 'both',
            'aria-owns': listId,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var updateFocus = useCallback(function (nextIndex) {
        var _a;
        (_a = document.getElementById(domId(nextIndex))) === null || _a === void 0 ? void 0 : _a.focus();
        setFocusIndex(nextIndex);
        onA11yPropsUpdate({
            role: 'combobox',
            'aria-expanded': 'true',
            'aria-autocomplete': 'both',
            'aria-activedescendant': domId(nextIndex),
            'aria-owns': listId,
        });
    }, [setFocusIndex, onA11yPropsUpdate, listId]);
    useKeyPress(['ArrowUp', 'ArrowLeft'], function () {
        var prevIndex = focusIndex !== null && focusIndex !== void 0 ? focusIndex : 1;
        var nextIndex = prevIndex === 0 ? options.length - 1 : prevIndex - 1;
        updateFocus(nextIndex);
    });
    useKeyPress(['ArrowDown', 'ArrowRight'], function () {
        var prevIndex = focusIndex !== null && focusIndex !== void 0 ? focusIndex : -1;
        var nextIndex = prevIndex === options.length - 1 ? 0 : prevIndex + 1;
        updateFocus(nextIndex);
    });
    return (React.createElement(OptionsList, { id: listId, "data-testid": "mui-auto-complete-list", role: "group" },
        !options.length && (React.createElement(OptionsItem, { id: "mui-auto-complete-no-results", role: "menuitem" },
            React.createElement(TextBody, { tag: "span", size: "md" }, "No results available"))),
        options.map(function (option, index) { return (React.createElement(OptionsItem, { id: domId(index), key: option.id, role: "menuitem", tabIndex: -1, "aria-label": option.label, onClick: function () {
                onSelect(option);
            }, onKeyPress: function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    onSelect(option);
                }
            } },
            React.createElement(TextBody, { tag: "span", size: "md" }, option.label))); })));
};
export { AutoCompleteSelect };
var templateObject_1, templateObject_2;
//# sourceMappingURL=AutoCompleteSelect.js.map